import { Dispatch } from 'redux';
import { updateNosRollout } from '../actions/event';
import { CheckoutState } from '../state';

export const getNosRollout =
    () => async (dispatch: Dispatch<CheckoutState>, _: () => CheckoutState) => {
        // Hardcoded values: scenario lucky number 7 and isNosSourceOfTruth true
        const scenario = 7;
        const isNosSourceOfTruth = true;

        await dispatch(
            updateNosRollout({
                scenario,
                isNosSourceOfTruth,
            }),
        );
    };
